import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { GenericOrderBy } from '../../components/_EOS/Table'
import { PositionAlert } from '../../interfaces/PositionAlerts/PositionAlerts'
import { Filter } from '../../components/_WMS/FilterComponent'

export const getPositionAlerts = (
  orderBy: GenericOrderBy<PositionAlert>,
  page: number = 0,
  pageSize: number = 5,
  filters: Filter[]
) => {
  const url = new URL(ApiConfig.PositionAlert)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  return axios.get(url.toString())
}
